module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play-ada7b9a9e54cda8abce40c8ef4776149.png";